import React from 'react';

import { BiRightArrowAlt } from 'react-icons/bi';

const WorkItems = ({item}) => {
  return (
    <div className="work__card" key={item.id}>
        <img src={item.image} alt="" className='work__img' />
        <h3 className="work__title">{item.title}</h3>
        <a 
        href={item.link} 
        className="work__button" 
        target="_blank" 
        rel="noopener noreferrer"
      >
        Show more <BiRightArrowAlt className='work__button-icon' />
      </a>
    </div>
  )
}

export default WorkItems;